<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="header-title">Advanced Data Table</h4> -->
            <p class="text-muted font-13 mb-0"></p>
            <!-- Table -->
            <div>
              <good-table-column-search
                :moduleapi="`${this.baseApi}/jobvacancy`"
                title="Job Vacancy"
                :columns="columns"
                routerpath="/hr/addjobvacancy"
                :formOptions="formOptions"
                :newPage="true"
                :edit="edit"
                :add="add"
                :canDelete="canDelete"
                :viewFields="viewFields"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoodTableColumnSearch from "../../../components/GoodTableColumnSearch.vue";
import moment from "moment";
const baseApi = process.env.VUE_APP_APIENDPOINT;
export default {
  components: {
    GoodTableColumnSearch,
  },
  data() {
    return {
      baseApi: process.env.VUE_APP_APIENDPOINT,
      viewFields: [
        {
          label: "Name",
          field: "name",
          type: "text",
          class: "col-md-6",
        },
        {
          label: "Department",
          field: "department",
          type: "dropdown",
          responseValue: "name",
          class: "col-md-6",
        },
        {
          label: "Position",
          field: "position",
          type: "dropdown",
          responseValue: "name",
          class: "col-md-6",
        },
        {
          label: "Status",
          field: "status",
          type: "text",
          class: "col-md-6",
        },
        {
          label: "Availability",
          field: "availability",
          type: "text",
          class: "col-md-6",
        },
        {
          label: "Proposed Salary",
          field: "proposedsalary",
          type: "text",
          class: "col-md-6",
        },
        {
          label: "Branch",
          field: "branch",
          type: "dropdown",
          responseValue: "name",
          class: "col-md-6",
        },
        {
          label: "Description",
          field: "description",
          type: "text",
          class: "col-md-6",
        },
      ],
      columns: [
        {
          label: "ID",
          field: "id",
          filterOptions: {
            enabled: true,
            placeholder: "Search ID",
          },
          hidden: true,
        },
        {
          label: "Name",
          field: "name",
          filterOptions: {
            enabled: true,
            placeholder: "Search Name",
          },
        },
        {
          label: "Department",
          field: "department",
          type: "dropdown",
          url: "getDepartment",
          responseValue: "name",
          dropdownname: "name",

          filterOptions: {
            enabled: true,
            placeholder: "Search Department",
          },
        },
        {
          label: "Position",
          field: "position",
          type: "dropdown",
          url: "getPosition",
          responseValue: "name",
          dropdownname: "name",
          filterOptions: {
            enabled: true,
            placeholder: "Search Position",
          },
        },
        {
          label: "Status",
          field: "status",
          filterOptions: {
            enabled: true,
            placeholder: "Search Status",
          },
        },
        {
          label: "Enter By",
          field: "enterby",
          type: "staticdropdown",
          url: "getUsers",
          responseValue: "fullname",
          filterOptions: {
            enabled: true,
            placeholder: "Search Name",
          },
        },
        {
          label: "Enter Date",
          field: "enterdatetime",
          type: "datetime",
          time: true,
          filterOptions: {
            enabled: true,
            placeholder: "Search Date",
          },
        },
        {
          label: "Modified By",
          field: "modifiedby",
          type: "staticdropdown",
          url: "getUsers",
          responseValue: "fullname",
          filterOptions: {
            enabled: true,
            placeholder: "Search Name",
          },
        },
        {
          label: "Modified Date",
          field: "modifieddatetime",
          time: true,
          type: "datetime",
          filterOptions: {
            enabled: true,
            placeholder: "Search Date",
          },
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      formOptions: {
        formTitle: `${this.$route.params.id ? "Edit Memo" : "Add Memo"}`,
        submitRouterPath: "/hr/jobvacancy",
        usersDropdown: true,
        branchDropdown: true,
        designationDropdown: true,
        method: "post",
        action: "add",
        url: `${baseApi}/team`,
        getEditValue: `${baseApi}/getjobvacancyById`,

        inputFields: [],
      },
      edit: "",
      add: "",
      canDelete: "",
    };
  },
  mounted() {
    const userData = JSON.parse(localStorage.getItem("UserRights"));
    const role = JSON.parse(localStorage.getItem("userData")).role;
    if (role !== "admin") {
      userData.map((item) => {
        if (item.modulename == "Job Vacancy") {
          this.edit = item.edit;
          this.add = item.add;
          this.canDelete = item.delete;
          if (item.edit !== 1 && item.add !== 1 && item.delete !== 1 && item.view !== 1) {
            this.$router.push("/");
          }
        }
      });
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
